import { MoreWaysItem } from "components/UI/molecules";
import { ACTIONS_MORE_WAYS_TO_USE } from "./utils/content";
import "./index.scss";

export const MoreWaysToUseGcx = () => {
  return (
    <section
      className="more-ways-to-use-gcx-section"
      data-testid="more-ways-to-use-gcx"
    >
      <h2 className="more-ways-section-title">More Ways to Use GCX</h2>
      <div className="more-ways-items-container">
        {ACTIONS_MORE_WAYS_TO_USE.map((item) => (
          <MoreWaysItem key={item.id} {...item} />
        ))}
      </div>
    </section>
  );
};
